
    <div class="o-tooltip o-tooltip__form">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <div class="o-tooltip__popup">
        <ng-container
          *ngIf="!tooltipString; else string"
          [ngTemplateOutlet]="tooltip"
        ></ng-container>
        <ng-template #string>{{ tooltip | lsTranslate }}</ng-template>
      </div>
    </div>
  